import { render, staticRenderFns } from "./Language_Independance.vue?vue&type=template&id=aad9cb0a&scoped=true"
import script from "./Language_Independance.vue?vue&type=script&lang=js"
export * from "./Language_Independance.vue?vue&type=script&lang=js"
import style0 from "./Language_Independance.vue?vue&type=style&index=0&id=aad9cb0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad9cb0a",
  null
  
)

export default component.exports